import React, { ReactNode, createContext, useState } from 'react';

export const SignupContext = createContext<any>('');

interface Props{
    children?:ReactNode
}

export const SignupProvider: React.FC<Props> = ({ children }) => {
  const [currentStep, setCurrentStep] = useState('BASIC');

  return (
    <SignupContext.Provider value={{ currentStep, setCurrentStep }}>
      {children}
    </SignupContext.Provider>
  );
};